import { configure } from './worker/useAxiosCore';
import { instance, plainInstance } from 'hooks/worker/axios';

configure({ axios: instance });

export type { AxiosError, AxiosResponse } from 'axios';
export { instance, plainInstance };
